var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row tools"},[_c('div',{staticClass:"col-md-12"},[_c('router-link',{staticClass:"btn",class:'btn-' + _vm.color,attrs:{"tag":"button","to":{ path: _vm.path }}},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "+_vm._s(_vm.name)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }